module.exports = __webpack_public_path__ + "static/media/_galapagos-islands.e5c47786.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_galapagos-islands.svg
// module id = 2322
// module chunks = 7